import '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';

const mapServerToSpecificationsBase = (serverVariant, brand)=>{
    const { erpId , opcoBackendId , sku , variantTypeDetails  } = serverVariant;
    let brandModelCode, faceShape, templeColor;
    if ((variantTypeDetails === null || variantTypeDetails === void 0 ? void 0 : variantTypeDetails.__typename) === 'SunglassesVariantTypeDetails' || (variantTypeDetails === null || variantTypeDetails === void 0 ? void 0 : variantTypeDetails.__typename) === 'FrameVariantTypeDetails') {
        var ref;
        var _brandModelCode;
        brandModelCode = (_brandModelCode = variantTypeDetails.brandModelCode) !== null && _brandModelCode !== void 0 ? _brandModelCode : undefined;
        var ref1;
        faceShape = (ref1 = variantTypeDetails.faceShape.map((el)=>el.shape
        ).join(', ')) !== null && ref1 !== void 0 ? ref1 : undefined;
        var ref2;
        templeColor = (ref2 = (ref = variantTypeDetails.frameFeatures) === null || ref === void 0 ? void 0 : ref.templeColor) !== null && ref2 !== void 0 ? ref2 : undefined;
    }
    const serverSpecifications = {
        brand,
        erpId,
        opcoBackendId,
        sku,
        brandModelCode,
        faceShape,
        templeColor
    };
    return getSpecificationItems(serverSpecifications);
};

export { mapServerToSpecificationsBase };
//# sourceMappingURL=map-server-to-specifications-base.js.map
